<template>
  <div class="wrapper">
    <div class="wrapper-nav">
      <navigation></navigation>
    </div>

    <div class="wrapper-content">
      <header-body></header-body>

      <div class="main-content container">
        <router-view></router-view>
      </div>

      <footer-body></footer-body>
    </div>
  </div>
</template>

<script>
import HeaderBody from '@/views/HeaderBody.vue'
import FooterBody from '@/views/FooterBody.vue'
import '@/styles/pages/main-layout.less'

export default {
  name: 'LayoutMain',
  components: {
    HeaderBody: HeaderBody,
    Navigation: () => import('@/views/Navigation.vue'),
    FooterBody: FooterBody
  },
  computed: {
    showNavigation() {
      if (this.$store.getters.HAS_NEURO_ADMIN) {
        return !!this.$route.query.hospital
      } else {
        return true
      }
    }
  }
}
</script>
